import React from "react";
import { Link } from "react-router-dom";
import { Settings as SettingsIcon, ChevronRight } from "lucide-react";
import { ProfileCard, HouseholdCard, AccountCard } from "../components/AccountControls";
import { InstallAffordance } from "../components/InstallAffordance";

export default function AccountHousehold() {
  return (
    <div className="max-w-2xl mx-auto px-6 md:px-10 py-10 md:py-14" data-testid="account-household-page">
      <div className="mb-8">
        <h1 className="font-display text-4xl tracking-tight font-medium text-[var(--ink)]">You</h1>
        <p className="text-[var(--ink3)] mt-2">Your profile, household, and data controls.</p>
      </div>

      <ProfileCard />
      <HouseholdCard />
      <AccountCard />

      <InstallAffordance variant="account" className="mb-6" />

      <Link
        to="/settings"
        data-testid="account-preferences-link"
        className="mt-2 flex items-center gap-3 rounded-2xl bg-[var(--surface)] border border-[var(--line)] shadow-[0_2px_8px_rgba(0,0,0,0.04)] px-5 py-4 transition-all duration-200 hover:border-[var(--pine)]"
      >
        <span className="h-9 w-9 rounded-full bg-[var(--pine-soft)] flex items-center justify-center text-[var(--pine)] shrink-0">
          <SettingsIcon size={17} strokeWidth={1.9} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[var(--ink)] font-medium">Preferences</span>
          <span className="block text-sm text-[var(--ink3)]">Notifications, reminders, and how Heldall sorts what you say.</span>
        </span>
        <ChevronRight size={18} strokeWidth={2} className="text-[var(--ink4)] shrink-0" />
      </Link>
    </div>
  );
}
